import Bugsnag from '~/lib/bugsnag'

export const logger = {
  error: (errorOrMessage: Error | string, context?: string) => {
    console.error(errorOrMessage)

    const error = errorOrMessage instanceof Error ? errorOrMessage : new Error(errorOrMessage)
    const message = error.message
    const errCode = (error as { code?: string }).code

    if (context) {
      Bugsnag.setContext(context)
    }

    Bugsnag.notify(error, (event) => {
      event.severity = 'error'

      event.addMetadata('error', {
        message,
        code: errCode,
        stack: error.stack,
      })
    })
  },
}
